import React, { useEffect, useState } from "react";
import { Link, useParams, useHistory, useLocation } from "react-router-dom";
import DatePicker from "react-datepicker";
import { Panel, PanelHeader, PanelBody, PanelFooter } from "../../components/panel/panel.jsx";
import { useDispatch, useSelector } from "react-redux";
import { comprobanteActions, pagoActions } from "../../store";
import TableShimmer from "../../components/table/TableShimmer.js";
import { useEffectAsync } from "../../helper/reactHelper";
import SweetAlert from "react-bootstrap-sweetalert";

import _ from "lodash";
import { formatDate, formatMoney, formatDate2Iso } from "../../helper/formatter.js";

const tipo_pago = [
    { value: 1, label: "EFECTIVO" },
    { value: 2, label: "CHEQUE" },
    { value: 3, label: "TRANSFERENCIA" },
];

const DatosTercero = () => {
    const { cobro_id } = useParams();

    const history = useHistory();
    const location = useLocation();
    const dispatch = useDispatch();

    const pago = useSelector((state) => state.pago.items[cobro_id]);
    const tercero = useSelector((state) => state.tercero.items);

    const [terceroSelected, setTerceroSelected] = useState(pago ? tercero[pago?.terceroId] : null);

    const [loading, setLoading] = useState(false);
    const [warn, setWarn] = useState({});

    const [datos, setDatos] = useState({
        id: cobro_id != 0 ? cobro_id : null,
        comprobantes: [],
        comentarios: pago?.comentarios || "",
        fecha_emision: pago ? new Date(formatDate2Iso(pago?.fecha_emision, "YYYY-MM-DD")) : new Date(),
        tipoPagoId: pago?.tipoPagoId || 1,
        razonsocial: terceroSelected?.razonsocial || "-",
        terceroId: null,
    });

    console.log(pago);
    console.log(datos);

    useEffect(() => {
        setTerceroSelected(pago ? tercero[pago?.terceroId] : null);
        setDatos({
            ...datos,
            comentarios: pago?.comentarios || "",
            tipoPagoId: pago?.tipoPagoId || 1,
            fecha_emision: pago ? new Date(formatDate2Iso(pago?.fecha_emision, "YYYY-MM-DD")) : new Date(),
        });
    }, [pago, tercero]);

    useEffect(() => {
        setDatos({
            ...datos,
            ["razonsocial"]: terceroSelected?.razonsocial || "-",
            ["terceroId"]: terceroSelected?.id,
        });
    }, [terceroSelected]);

    const [importe, setImporte] = useState(0);

    useEffectAsync(async () => {
        if (cobro_id == 0) {
            let dc = _.map(location.state?.comprobantes, (comprobante) => {
                let comp_pago = _.find(comprobante.comprobante_pagos, (cp) => cp.pagoId == cobro_id);
                return {
                    ...comprobante,
                    ["abono"]: cobro_id == 0 ? comprobante.pendiente : comp_pago?.monto || 0,
                };
            });

            setDatos({
                ...datos,
                ["comprobantes"]: dc,
                ["razonsocial"]: tercero[dc[0]?.terceroId].razonsocial || "",
                ["terceroId"]: dc[0]?.terceroId,
            });
        } else {
            setLoading(true);
            try {
                const response = await fetch(`/api/pago/${cobro_id}/ComprobantePago`);
                if (response.ok) {
                    let comprobantePagos = await response.json();
                    let cp = _.map(comprobantePagos, (cp) => ({
                        ...cp.comprobante,
                        ["abono"]: cp.monto,
                    }));
                    setDatos({ ...datos, ["comprobantes"]: cp });
                } else {
                    throw Error(await response.text());
                }
            } finally {
                setLoading(false);
            }
        }
    }, [cobro_id]);

    const handleInputChange = (event) => {
        setDatos({ ...datos, [event.target.name]: event.target.value });
    };

    const handleSave = async (event) => {
        event.preventDefault();
        const apiUrl = cobro_id == 0 ? "/api/pago/registrar" : "/api/pago/actualizar";

        const response = await fetch(apiUrl, {
            method: cobro_id == 0 ? "POST" : "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ ...datos, ["importe"]: importe }),
        });

        if (response.ok) {
            let pago = await response.json();
            let comprobantesIds = _.map(datos.comprobantes, "id");
            let arrIds = encodeURIComponent(JSON.stringify(comprobantesIds));
            const response_comprobantes = await fetch("/api/comprobante/getById?ids=" + arrIds);
            if (response_comprobantes.ok) {
                let comprobantes = await response_comprobantes.json();
                dispatch(comprobanteActions.update(comprobantes));
            }
            dispatch(pagoActions.update([pago]));
            history.goBack();
        } else {
            throw Error(await response.text());
        }
    };

    const handleDelete = async () => {
        let comprobantesIds = _.map(datos.comprobantes, "id");
        let arrIds = encodeURIComponent(JSON.stringify(comprobantesIds));
        await fetch(`/api/pago/${cobro_id}?comprobantesIds=` + arrIds, { method: "DELETE" });
        dispatch(pagoActions.remove(cobro_id));

        const response_comprobantes = await fetch("/api/comprobante/getById?ids=" + arrIds);
        if (response_comprobantes.ok) {
            let comprobantes = await response_comprobantes.json();
            dispatch(comprobanteActions.update(comprobantes));
        }

        history.goBack();
    };

    useEffect(() => {
        let suma = 0.0;
        _.each(datos.comprobantes, (c) => (suma += parseFloat(c.abono)));
        setImporte(suma);
    }, [datos]);

    const handleItemChanged = (e, i) => {
        e.preventDefault();
        let comprobantes = Object.assign([], datos.comprobantes);
        comprobantes[i]["abono"] = e.target.value;
        setDatos({ ...datos, ["comprobantes"]: comprobantes });
    };

    const removeRow = (i) => {
        let comprobantes = Object.assign([], datos.comprobantes);
        comprobantes.splice(i, 1);
        setDatos({ ...datos, ["comprobantes"]: comprobantes });
    };

    const eliminarRegistroDialog = () => {
        setWarn({
            message: `Esta seguro que desea eliminar este registro de forma permanente`,
        });
    };

    return (
        <div>
            <ol className="breadcrumb float-xl-end">
                <li className="breadcrumb-item">
                    <Link to="/">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                    <Link to="/venta/registro_cobros">Registro de cobros</Link>
                </li>
                <li className="breadcrumb-item active">Cobro</li>
            </ol>
            <h1 className="page-header">Datos de cobro</h1>

            <div className="row mb-3">
                <div className="col-xl-12">
                    <Panel>
                        {!_.isEmpty(warn) && (
                            <SweetAlert
                                danger
                                showCancel
                                confirmBtnText="Continuar"
                                cancelBtnText="Cancelar"
                                confirmBtnBsStyle="danger"
                                cancelBtnBsStyle="default"
                                title="Eliminar registro de cobro"
                                onConfirm={() => handleDelete()}
                                onCancel={() => setWarn({})}>
                                {warn.message}
                            </SweetAlert>
                        )}

                        <PanelHeader>Cobro id: {cobro_id || " Nuevo registro"}</PanelHeader>
                        <PanelBody>
                            <div className="row mb-md-4">
                                <div className="col-md-5 col-12">
                                    <label className="form-label">Razon social que cancela:</label>
                                    <input
                                        disabled
                                        type="text"
                                        className="form-control fs-15px"
                                        placeholder="Razon social"
                                        onChange={handleInputChange}
                                        name="razonsocial"
                                        value={datos.razonsocial}
                                    />
                                </div>

                                <div className="col-12 col-md-2 mb-2">
                                    <label className="form-label">Fecha cobro:</label>
                                    <DatePicker
                                        selected={datos.fecha_emision}
                                        dateFormat="dd/MM/yyyy"
                                        locale="es"
                                        onChange={(date) =>
                                            setDatos({
                                                ...datos,
                                                ["fecha_emision"]: date,
                                            })
                                        }
                                        className="form-control"
                                    />
                                </div>

                                <div className="col-12 col-md-2 mb-2">
                                    <label className="form-label">Tipo de pago</label>
                                    <select
                                        className="form-select"
                                        value={datos.tipoPagoId}
                                        onChange={handleInputChange}
                                        name="tipoPagoId">
                                        {_.map(tipo_pago, (item) => (
                                            <option key={item.value} value={item.value}>
                                                {item.label}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div className="col-12 col-md-2 mb-2">
                                    <label className="d-flex align-items-center fs-13px">Importe:</label>
                                    <input
                                        type="text"
                                        className="form-control fs-15px"
                                        placeholder="$ 0.00"
                                        onChange={(e) => setImporte(e.target.value)}
                                        name="importe"
                                        value={formatMoney(importe)}
                                        disabled
                                    />
                                </div>

                                <div className="col-12 col-md-7 mb-2">
                                    <label className="d-flex align-items-center fs-13px">Comentarios:</label>
                                    <input
                                        type="text"
                                        className="form-control fs-15px"
                                        placeholder="Comentarios"
                                        onChange={handleInputChange}
                                        name="comentarios"
                                        value={datos.comentarios}
                                    />
                                </div>
                            </div>

                            <hr />

                            <div className="table-responsive">
                                <table
                                    className={
                                        `table table-bordered widget-table align-middle rounded table-sm` +
                                        (!loading && `table-hover table-striped`)
                                    }>
                                    <thead>
                                        <tr className="text-nowrap">
                                            <th>#</th>
                                            <th>COMPROBANTE</th>
                                            <th>FECHA</th>
                                            <th>IMPORTE DE FACTURA</th>
                                            <th>MONTO PENDIENTE</th>
                                            <th>MONTO ABONO</th>
                                            <th width="10%"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {!loading ? (
                                            _.map(datos.comprobantes, (item, i) => {
                                                return (
                                                    <tr key={i}>
                                                        <td>{parseInt(i) + 1}</td>

                                                        <td>
                                                            <Link
                                                                to={`/venta/comprobante/${item.id}`}
                                                                className="fw-bold text-nowrap">
                                                                {item.talonario?.serie + item.n_comprobante}
                                                            </Link>
                                                        </td>

                                                        <td>{formatDate(item.fecha_emision)}</td>
                                                        <td>{formatMoney(item.importe)}</td>
                                                        <td>{formatMoney(item.pendiente <= 0 ? 0 : item.pendiente)}</td>
                                                        <td>
                                                            <input
                                                                type="number"
                                                                className="form-control form-control-sm"
                                                                value={item.abono}
                                                                onChange={(e) => handleItemChanged(e, i)}
                                                            />
                                                        </td>
                                                        <td>
                                                            <button
                                                                className="btn btn-xs w-40px btn-danger ms-1"
                                                                onClick={() => removeRow(i)}>
                                                                <i className="fa fa-times"></i>{" "}
                                                            </button>
                                                        </td>
                                                    </tr>
                                                );
                                            })
                                        ) : (
                                            <TableShimmer columns={7} enableAnimation />
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </PanelBody>

                        <PanelFooter className="text-center border-1">
                            <a onClick={() => history.goBack()} className="btn btn-default btn-lg ms-5px mb-2">
                                Atras
                            </a>
                            {cobro_id == 0 ? null : (
                                <a onClick={eliminarRegistroDialog} className="btn btn-danger btn-lg ms-5px mb-2">
                                    Borrar Registro
                                </a>
                            )}
                            <a onClick={handleSave} className="btn btn-primary btn-lg ms-5px mb-2">
                                Guardar Registro
                            </a>
                        </PanelFooter>
                    </Panel>
                </div>
            </div>
        </div>
    );
};

export default DatosTercero;
